<template>
  <div id="tableGrid" :class="[columns.length>3 ? 'scroll-bar' : '']">
    <p class="table-title">{{fields.title}}</p>
    <tr :class="backgroundColorClass(fields.color)">
      <td class="border">
        <!-- empty for corner -->
      </td>
      <td v-for="column in columns" :key="column.sys.id" class="col-title border">
        {{column.fields.title}}
      </td>
    </tr>
    <tr class="columns" v-for="(label, labelIndex) in rowLabels" :key="label.sys.id" :class="[labelIndex%2 ? backgroundLightColorClass(fields.color) : '']">
      <td class="border text-center">
        <ctf-rich-text class="no-p-margin"
              v-if="label.fields.labelText"
              :document="label.fields.labelText"
            />
      </td>
      <td v-for="(column, colIndex) in columns" :key="column.sys.id" class="border text-center">
        <ctf-rich-text class="no-p-margin"
          v-if="colValues[colIndex][labelIndex].fields.content"
          :document="colValues[colIndex][labelIndex].fields.content"
        />
        <div
        v-if="
        colValues[colIndex][labelIndex].sys.contentType.sys.id.toString() === 'tableColumnCheckmark'">
          <img v-if="
            colValues[colIndex][labelIndex].fields.hasCheckmark"
            src='/assets/checkmark.png' width='15px' height='15px'>
          <img v-if="
            !colValues[colIndex][labelIndex].fields.hasCheckmark"
            src='/assets/x.png' width='15px' height='15px'>
        </div>
      </td>
    </tr>
  </div>
</template>

<script>

import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import { backgroundColorClass, backgroundLightColorClass } from '@/utils/helpers'

export default {
  name: 'TableGrid',
  components: {
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      columns: [],
      colValues: [],
      rowLabels: []
    }
  },
  async created () {
    const { items, includes } = await queryCTF(
      `&include=2&content_type=tableGrid&select.fields&sys.id=${this.sysId}`
    )
    if (items && includes) {
      const group = items[0]
      const colEntries = includes.Entry.filter((x) =>
        group.fields.columns.find((t) => t.sys.id === x.sys.id)
      )

      const sortedColEntries = await sortCTFEntries(
        group.fields.columns,
        colEntries
      )
      this.columns = sortedColEntries
      for (let i = 0; i < this.columns.length; i++) {
        const { items, includes } = await queryCTF(
          `&include=2&content_type=tableColumn&select.fields&sys.id=${this.columns[i].sys.id}`
        )

        if (items && includes) {
          const group = items[0]
          const completeEntries = []

          // these loops are necessary for when a single column has multiple identical checkmark entries
          for (let i = 0; group.fields.columnValues.length > i; i++) {
            for (let j = 0; includes.Entry.length > j; j++) {
              if (group.fields.columnValues[i].sys.id === includes.Entry[j].sys.id) {
                completeEntries.push(includes.Entry[j])
                break
              }
            }
          }
          const sortedEntries = await sortCTFEntries(
            group.fields.columnValues,
            completeEntries
          )
          this.colValues[i] = sortedEntries
        }
      }
      this.fetchRowLabels(items[0].fields.rowLabels.sys.id) // items from tableGrid query
      this.color = items[0].fields.color
    }
  },
  methods: {
    backgroundColorClass,
    backgroundLightColorClass,
    async fetchRowLabels (labelsId) {
      const { items, includes } = await queryCTF(
        `&include=2&content_type=tableLabelGroup&select.fields&sys.id=${labelsId}`
      )

      if (items && includes) {
        const group = items[0]
        const entries = includes.Entry.filter((x) =>
          group.fields.rowLabels.find((t) => t.sys.id === x.sys.id)
        )
        const sortedEntries = await sortCTFEntries(
          group.fields.rowLabels,
          entries
        )
        this.rowLabels = sortedEntries
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.background {
  position: relative;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}

.border{
  border: black 1px solid;
}

.text-center{
  text-align: center;
  padding: auto;
  vertical-align: middle;
}

td{
  padding:6px;
  min-width:235px;
}

.scroll-bar {
  overflow-x: scroll;
}

.table-title{
  color:#033f60;
  font-size: 24pt;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
}

.col-title{
  font-size: 21pt;
  font-weight: bold;
  color:black;
}

tr{
  &.primary, &.warning, &.accent{
    .col-title{
      color:white;
    }
  }
}

@media only screen and (max-width: 768px) {
  //mobile and tablet
  .table-title{
    font-size: 18pt;
  }
  .col-title{
    font-size:16pt;
  }
  td{
    padding:3px;
    min-width:150px;
  }
}

</style>
